import GenericColumn from "@isceco/widget-library2/basic-elements/List/column/GenericColumn.js";
import DateTimeCell from "@isceco/widget-library2/basic-elements/List/cell/DateTimeCell.js";
import {html} from "@isceco/widget-library2/external/lit";
import StringCell from "@isceco/widget-library2/basic-elements/List/cell/StringCell";
import StyledCell from "../../components/StaticDetailList/StyledCell";

export default class VerfuegungVersandKonfigColumns {
  static getColumns(handleDownload) {
    return [
      VerfuegungVersandKonfigColumns.ELEKTRONISCHES_COLUMN(handleDownload),
      VerfuegungVersandKonfigColumns.CREATED_BY_COLUMN(),
      VerfuegungVersandKonfigColumns.CREATED_ON_COLUMN(),
      VerfuegungVersandKonfigColumns.ARCHIVED_ON_COLUMN()
    ]
  }

  static ELEKTRONISCHES_COLUMN(handleDownload) {
    return new GenericColumn({
      key: 'elektronisches',
      text: 'gp.stammdaten.versandKonfig.header.elektronisches',
      sortable: true,
      cell: VerfuegungVersandKonfigColumns._formatiert({
        render: (i18n, _, row) => {
          const pdfDownload = !handleDownload || !row.elektronisches ? html`` : html`
            <isceco-button icon="file pdf outline" size="small" variant="tertiary"
                           @click=${() => handleDownload(row)}
                           title="${i18n.translate('gp.stammdaten.versandKonfig.elektronisches.pdfDownload')}"
            ></isceco-button>
          `
          return html`
            <div style="display: flex; align-items: center;">
              ${i18n.translate('gp.stammdaten.versandKonfig.elektronisches.' + (row.elektronisches ? 'yes' : 'no'))}
              ${pdfDownload}
            </div>
          `
        }
      })
    })
  }

  static CREATED_BY_COLUMN() {
    return new GenericColumn({
      key: 'createdBy',
      cell: VerfuegungVersandKonfigColumns._formatiert(new StringCell()),
      text: 'gp.stammdaten.versandKonfig.header.createdBy',
      sortable: true
    })
  }

  static CREATED_ON_COLUMN() {
    return new GenericColumn({
      key: 'createdOn',
      cell: VerfuegungVersandKonfigColumns._formatiert(new DateTimeCell()),
      text: 'gp.stammdaten.versandKonfig.header.createdOn',
      sortable: true
    })
  }

  static ARCHIVED_ON_COLUMN() {
    return new GenericColumn({
      key: 'archivedOn',
      cell: VerfuegungVersandKonfigColumns._formatiert(new DateTimeCell()),
      text: 'gp.stammdaten.versandKonfig.header.archivedOn',
      sortable: true
    })
  }

  static _formatiert(cell) {
    return new StyledCell(cell, row => row.archivedOn ? 'color: var(--isceco-color-grey-700)' : '')
  }
}
